import "./TestimonialVideo.css";
import SectionTitle from "../../../../components/SectionTitle/SectionTitle";
import { useAppContext } from "../../../../context/AppState/AppContext";
import { Carousel } from "@mantine/carousel";
import { Modal } from "@mantine/core";
import { useState, useEffect } from "react";




const TestimonialVideo = () => {



    const { jsonTexts, jsonMedia } = useAppContext();
    const { title, subtitleTag } = jsonTexts.inicio.testimonialGrid;
    const videos = jsonMedia?.inicio?.testimonialCarousel

    const [selectedVideo, setSelectedVideo] = useState(null)
    return (
        <div className="testimonialVideo-grid-wrapper">
            <SectionTitle upText={subtitleTag} downText={title} />

            <div className="testimonialVideo-grid-container">
                {videos && videos?.length > 0 && <Carousel
                    mt={16}
                    slideSize={'25%'}
                    loop
                    align="start"
                    slideGap={24}
                    slidesToScroll={1}
                    withIndicators
                    withControls
                >
                    {videos.map(item => {
                        return (
                            <Carousel.Slide key={item}>
                                <div onClick={() => setSelectedVideo(item)} className="video-thumbnail">
                                    {item.placeholder ? (
                                        <img src={item.placeholder} alt="Video preview" style={{ width: "100%", height: '456px', borderRadius: "var(--border-radius-md)", objectFit: "cover" }} />
                                    ) : (
                                        <div style={{ width: "100%", height: "456px", background: "#ccc", borderRadius: "var(--border-radius-md)" }} />
                                    )}
                                </div>
                            </Carousel.Slide>
                        )
                    })}
                </Carousel>
                }

                {/* Modal con el iframe */}
                <Modal
                    opened={!!selectedVideo}
                    onClose={() => setSelectedVideo(null)}
                    size="xl"
                    centered
                    overlayProps={{ backgroundOpacity: 0.6, blur: 4 }}
                >
                    {selectedVideo && (
                        <div onClick={e => e.stopPropagation()}>
                            <video
                                controls
                                autoPlay
                                width="100%"
                                height="480"
                            >
                                <source src={selectedVideo.src} type="video/mp4" />
                                Tu navegador no soporta el video.
                            </video>

                        </div>
                    )}
                </Modal>
            </div>
        </div>
    );

};

export default TestimonialVideo;
